import moment from 'moment';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';

// Constants & Actions
import * as AppointmentActions from './reducers/actions';
import { updateCommonFilters } from '../reducer/commonActions';
import {
  TAB_PATIENT,
  TAB_INVOICE,
  TAB_PAYMENTS,
  STATUS_STARTED,
  STATUS_RADIOLOGY_START_DURING_CONSULTATION,
  STATUS_RADIOLOGY_START
} from 'services/constants';

// Components
import NavigationBar from './components/NavigationBar/NavigationBar';
import TimeLine from './components/TimeLine';
import InfoHeader from './components/InfoHeader/InfoHeader';
import InternalHeader from '../components/InternalHeader/InternalHeader';
// modals
import PaymentModal from './components/PaymentModal';
import VerifyModal from 'src/views/practitioner/components/VerifyModal';
import BlockModal from 'src/views/practitioner/components/BlockModal';
import SendToRadiologyModal from 'src/views/practitioner/components/SendToRadiologyModal';
// tabs
import PatientTab from './tabs/PatientTab';
import InvoiceTab from './tabs/InvoiceTab';
import PaymentsTab from './tabs/PaymentsTab';

// Styles & Images
import ArrowBack from 'assets/images/appointment/arrow-back.svg';
import * as styles from './styles';

class Appointment extends Component {
  constructor() {
    super();
    this.state = {
      paymentModalIsOpen: false,
      verifyPatientIsOpen: false,
      blockPatientIsOpen: false,
      radiologyIsOpen: false
    };

    this.triggerPaymentModal = this.triggerPaymentModal.bind(this);
    this.openVerifyModal = this.openVerifyModal.bind(this);
    this.closeVerifyModal = this.closeVerifyModal.bind(this);
    this.openBlockModal = this.openBlockModal.bind(this);
    this.closeBlockModal = this.closeBlockModal.bind(this);
    this.openRadiologyModal = this.openRadiologyModal.bind(this);
    this.closeRadiologyModal = this.closeRadiologyModal.bind(this);
    this.submitRadiology = this.submitRadiology.bind(this);
    this.blockPatientVerifyModal = this.blockPatientVerifyModal.bind(this);
    this.changeTab = this.changeTab.bind(this);
  }

  componentDidMount() {
    let {
      appointment: { activeAppointment },
      match: { params },
      actions
    } = this.props;

    if (activeAppointment.patient && activeAppointment.appointment) {
      const { externalAppointmentId } = activeAppointment.appointment.entity;
      actions.loadPatientById(activeAppointment.patient.externalId);
      actions.loadWorkflowTimeline(externalAppointmentId);
    } else {
      actions.loadAppointmentById(params.appointmentId, actions.loadPatientById);
    }
  }

  componentDidUpdate() {
    const {
      appointment: { activeAppointment },
      common: {
        commonFilters: { practitionerId }
      },
      updateCommonFilters
    } = this.props;
    if (
      !practitionerId &&
      activeAppointment &&
      activeAppointment.practitioner &&
      activeAppointment.practitioner.id
    ) {
      updateCommonFilters({ practitionerId: activeAppointment.practitioner.id });
    }
  }

  componentWillUnmount() {
    // const { actions } = this.props;
    // actions.clearAppointment();
  }

  triggerPaymentModal() {
    const { paymentModalIsOpen } = this.state;
    this.setState({ paymentModalIsOpen: !paymentModalIsOpen });
  }

  openVerifyModal() {
    this.setState({ verifyPatientIsOpen: true });
  }

  closeVerifyModal() {
    this.setState({ verifyPatientIsOpen: false });
  }

  openBlockModal() {
    this.setState({ blockPatientIsOpen: true });
  }

  closeBlockModal() {
    this.setState({ blockPatientIsOpen: false });
  }

  openRadiologyModal() {
    // this.setState({ radiologyIsOpen: true });
    this.submitRadiology();
  }

  closeRadiologyModal() {
    this.setState({ radiologyIsOpen: false });
  }

  submitRadiology(data) {
    const {
      actions,
      appointment: {
        activeAppointment: {
          appointment: {
            entity: { externalAppointmentId, id },
            viewModel: { state }
          }
        }
      }
    } = this.props;
    if (state && state === STATUS_STARTED) {
      actions.triggerWorkflow(
        STATUS_RADIOLOGY_START_DURING_CONSULTATION,
        externalAppointmentId,
        id,
        data
      );
    } else {
      actions.triggerWorkflow(STATUS_RADIOLOGY_START, externalAppointmentId, id, data);
    }
    this.closeRadiologyModal();
  }

  blockPatientVerifyModal() {
    this.closeVerifyModal();
    this.openBlockModal();
  }

  changeTab(tab) {
    let {
      actions,
      appointment: {
        activeAppointment: {
          appointment: {
            entity: { externalAppointmentId }
          }
        }
      }
    } = this.props;
    actions.changeTab(tab);
    actions.loadWorkflowTimeline(externalAppointmentId);
  }

  viewTab() {
    const {
      i18n,
      appointment,
      appointment: { activeAppointment },
      match: { params },
      actions
    } = this.props;

    switch (appointment.activeTab) {
      case TAB_PATIENT:
        return (
          <PatientTab
            verifyPatientIsOpen={this.state.verifyPatientIsOpen}
            patient={activeAppointment.patient}
            note={activeAppointment.note}
            profile={appointment.patient}
            clearPatient={actions.clearPatient}
            openVerifyModal={this.openVerifyModal}
            i18n={i18n}
          />
        );
      case TAB_INVOICE:
        return (
          <InvoiceTab
            i18n={i18n}
            appointmentId={params.appointmentId}
            actions={actions}
            appointment={appointment}
            openPaymentModal={this.triggerPaymentModal}
          />
        );
      case TAB_PAYMENTS:
        return (
          <PaymentsTab
            i18n={i18n}
            appointmentId={params.appointmentId}
            invoice={appointment.invoice}
          />
        );
      default:
        return null;
    }
  }

  render() {
    const {
      common: { backUrl },
      i18n,
      appointment,
      appointment: { activeAppointment },
      actions,
      role,
      push
    } = this.props;
    const { paymentModalIsOpen } = this.state;

    if (!activeAppointment.patient) return null;

    let appointmentDate = moment(activeAppointment.dateTime);
    let day =
      appointmentDate
        .format('dddd')
        .charAt(0)
        .toUpperCase() + appointmentDate.format('dddd').slice(1);
    let date = `${day} ${appointmentDate.format('DD.MM.YYYY')}`;
    let { campus = {}, patient = {}, creator = {}, practitioner = {} } = activeAppointment;

    return (
      <div>
        <InternalHeader />
        <styles.Container>
          <styles.BreadCrumps>
            <Link to={backUrl && backUrl.url || '/practitioner/appointments/today'}>
              <img src={ArrowBack} alt="Back arrow" />
            </Link>
            <span>{i18n.t('appointment')}</span>
          </styles.BreadCrumps>

          <InfoHeader
            campus={campus}
            date={date}
            activeAppointment={activeAppointment}
            patient={patient}
            practitioner={practitioner}
            appointment={appointment}
            i18n={i18n}
          />

          <styles.CenterContainer>
            <styles.DataGeneralWrapper>
              <NavigationBar
                i18n={i18n}
                activeTab={appointment.activeTab}
                changeTab={this.changeTab}
                role={role}
              />

              {this.viewTab()}
            </styles.DataGeneralWrapper>

            <TimeLine
              i18n={i18n}
              appointment={appointment}
              creator={creator}
              actions={actions}
              openPaymentModal={this.triggerPaymentModal}
              openVerifyModal={this.openVerifyModal}
              openRadiologyModal={this.openRadiologyModal}
              activeAppointment={activeAppointment}
              role={role}
            />
          </styles.CenterContainer>          
        </styles.Container>
        {/* ──── Modals ───────────────────────────────────────────────────────────────────── */}

        <PaymentModal isOpen={paymentModalIsOpen} closeModal={this.triggerPaymentModal} />

        <VerifyModal
          isOpen={this.state.verifyPatientIsOpen}
          i18n={i18n}
          profile={appointment.patient}
          verifyPatient={actions.verifyPatient}
          blockPatient={this.blockPatientVerifyModal}
          closeModal={this.closeVerifyModal}
        />

        <BlockModal
          isOpen={this.state.blockPatientIsOpen}
          i18n={i18n}
          blockPatient={actions.blockPatient}
          profile={appointment.patient}
          closeModal={this.closeBlockModal}
        />

        <SendToRadiologyModal
          isOpen={this.state.radiologyIsOpen}
          closeModal={this.closeRadiologyModal}
          onSubmit={this.submitRadiology}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  appointment: state.practitioner.appointment,
  common: state.practitioner.common,
  role: state.auth.role
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppointmentActions, dispatch),
  updateCommonFilters: dataObj => dispatch(updateCommonFilters(dataObj)),
  push: path => dispatch(push(path))
});

export default translate()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Appointment)
);
